import { Component, OnInit } from '@angular/core';
import { SaveAuditService } from 'src/app/shared/utils/save-audit.service';

@Component({
  selector: 'app-login-layout',
  template: `
    <router-outlet></router-outlet>
    <router-outlet name="notification"></router-outlet>
    <router-outlet name="popup"></router-outlet>
  `,
  styles: []
})
export class LoginLayoutComponent implements OnInit {
  constructor(
    private saveAuditService: SaveAuditService,
  ) { }

  ngOnInit() {
    this.saveAuditService.registerAndSaveAuditLog();
  }
}
